import { __exportAll } from "./_virtual/_rolldown/runtime.js";
import "./eigen_api_server.js";
//#region src/eigen_api_server_helper.ts
var eigen_api_server_helper_exports = /* @__PURE__ */ __exportAll({
	isSandbox: () => isSandbox,
	name: () => name
});
function name(apiServer) {
	switch (apiServer) {
		case 1: return "Sandbox 1";
		case 2: return "Sandbox 2";
		case 3: return "Production 1";
		case 4: return "Production 2";
	}
}
function isSandbox(apiServer) {
	switch (apiServer) {
		case 1:
		case 2: return true;
		case 3:
		case 4: return false;
	}
}
//#endregion
export { eigen_api_server_helper_exports, isSandbox, name };

//# sourceMappingURL=eigen_api_server_helper.js.map